import axios from 'axios';
import { containerValidator } from '../utils';
import { TABLE } from '../const';

class GateInsService {
  getAll = (props: any) => axios.get(`/gate-ins`, props);

  add = (props: any) => axios.post(`/gate-ins`, props);

  complete = async ({ id, props }: any) => axios.patch(`/gate-ins/${id}`, props);

  options = (props: any) => async () => {
    const res = await gateInsService.getAll({
      params: { take: TABLE.PAGE_MAX_SIZE, skip: 0, notLoading: true, ...props },
    });

    const data = res.data.data.map((container: any) => ({
      ...container,
      label: container.number,
      id: container.id,
    }));

    if (containerValidator(props.containerNumber) && !data.length) {
      data.push({
        label: props.containerNumber,
        isNew: true,
      });
    } else if (props.containerNumber && !data.length) {
      data.push({
        id: 'fakeID',
        label: props.containerNumber,
        isWrong: true,
      });
    }

    return data;
  };
}

export const gateInsService = new GateInsService();
